export default __webpack_public_path__ + "static/media/gamers_v2.186bb1f7.jpg";